import { useUserStore } from '@/stores/user';
import type { BeforeInstallPromptEvent } from '@/pwa/types';

export function registerPwaInstallPromptListener(): void {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    const userStore = useUserStore();
    userStore.pwaInstallation.beforeInstallPromptEvent =
      e as BeforeInstallPromptEvent;
  });

  window.addEventListener('appinstalled', () => {
    const userStore = useUserStore();
    userStore.pwaInstallation.beforeInstallPromptEvent = null;
  });
}
